import styled from 'styled-components';

export const FixedButtonWrapper = styled.div`
    position: fixed;
    max-width: 250px;
    width: 100%;
    bottom: 2.5%;
    left: 50%;
    transform: translate(-50%, 0);
    z-index: 1;
`;